import userReducer from './user';
import docsReducer from './docs';

const mainReducer = ({ user, docs }, action) => ({
  user: userReducer(user, action),
  docs: docsReducer(docs, action),
});

export default mainReducer;
